import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { BarChart3, Settings, ArrowRightLeft, Library, PieChart, LayoutGrid, Calculator } from "lucide-react";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/partner/portfoliomanagement/dist", icon: BarChart3 },
  { label: "Dist Fund Holdings and Weightings", path: "/partner/portfoliomanagement/dist/funds", icon: Settings },
  { label: "Holdings Sector Appropriating", path: "/partner/portfoliomanagement/dist/sector-weightings", icon: PieChart },
  { label: "Dist Sector Weightings", path: "/partner/portfoliomanagement/dist/dist-sector-weightings", icon: LayoutGrid },
  { label: "Hypothetical Asset Allocation Calculator", path: "/partner/portfoliomanagement/dist/hypothetical-calculator", icon: Calculator },
  { label: "Trade Log", path: "/partner/portfoliomanagement/dist/trades", icon: ArrowRightLeft },
  { label: "Investable Universe", path: "/partner/portfoliomanagement/dist/universe", icon: Library },
];

export default function DistBenchmarkLayout() {
  const location = useLocation();
  return (
    <div className="min-h-screen">
      <div className="border-b bg-muted/30 mt-6 pt-2">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-1 h-12 w-full overflow-x-auto">
            {NAV_ITEMS.map((item) => {
              const isActive = item.path === "/partner/portfoliomanagement/dist"
                ? location.pathname === item.path
                : location.pathname === item.path || location.pathname.startsWith(item.path + "/");
              return (
                <Link key={item.path} to={item.path} className={cn(
                  "flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap",
                  isActive ? "bg-primary text-primary-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}>
                  <item.icon className="h-4 w-4" />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
      <div className="px-4 sm:px-6 lg:px-8 py-6"><Outlet /></div>
    </div>
  );
}
